// extracted by mini-css-extract-plugin
export default {"sec":"Projects_sec__nZ8yG"};